import React, {useMemo, useRef} from "react";
import {Player} from "@lottiefiles/react-lottie-player";
import src from "../../../../../assets/animations/lottie/importing.json";
import classnames from "classnames";

const ImportingLottieAnimation = ({className, width = '100%', height = 'auto'}) => {
    const playerRef = useRef();
    const lottieRef = useRef();

    /**
     * Fetches the value of the given dimension.
     *
     * * if the given [d] is a number, returns the pixelated value of the [d], otherwise returns [d]
     * @param {number | string} d
     * @return {string|*}
     */
    const getDimensionValue = (d) => {
        const num = Number(d);
        if (Number.isNaN(num)) {
            return d;
        }
        return `${num}px`;
    }

    const dimensions = useMemo(() => ({
        width: getDimensionValue(width),
        height: getDimensionValue(height),
    }), [width, height])

    return (
        <>
            <Player
                autoplay
                loop
                src={src}
                ref={playerRef}
                style={{...dimensions}}
                lottieRef={(ref) => (lottieRef.current = ref)}
                className={classnames(className)}
            />
        </>
    )
}

export default ImportingLottieAnimation;
